const Button = ({children, onClick, className, disabled = false}) => {
  return (
    <button
      onClick={onClick}
      className={`bg-[#1a2951] rounded-full focus:outline-none   
       text-white text-[2rem] font-light leading-none 
        flex items-center
        gap-[3.25rem]
        overflow-hidden
        ${disabled ? 'pointer-events-none' : ''}
        ${className}`}
    >
      {children}
    </button>
);
};

export default Button;